import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteTypeaheadSharedModule } from '../typeahead';

import { ClienteCentralCompraV1Component } from './cliente-central-compra-v1.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteTypeaheadSharedModule
    ],
    declarations: [
        ClienteCentralCompraV1Component
    ],
    exports: [
        ClienteCentralCompraV1Component
    ]
})
export class ClienteCentralCompraV1Module { }
